import { jsx } from "@emotion/react/jsx-runtime";
import "react";
import iconContext from "./iconContext.mjs";
function IconProvider(_ref) {
  let {
    children,
    icons,
    getIconSrc,
    ...restProps
  } = _ref;
  if (!getIconSrc && icons) {
    getIconSrc = name => icons[name];
  }
  return /* @__PURE__ */jsx(iconContext.Provider, {
    value: {
      icons,
      getIconSrc,
      ...restProps
    },
    children
  });
}
export { IconProvider as default };